import React from 'react'
import { useAppSelector } from '../../hooks/redux'

import { getIDs } from './helpers'

import { selectNotification } from '../../slices/notification'
import { useUserAPI } from '../UserAPIProvider'

const NotificationListProvider = ({ children }) => {
  const { all } = useAppSelector(selectNotification)

  const { loadUser } = useUserAPI()

  // Loads users involved in the notifications
  React.useEffect(() => {
    const ids = new Set<string>()

    Object.values(all).forEach(notif => {
      ids.add(notif.src_user_id)
      const foundIDs = getIDs(notif.body)
      foundIDs.forEach(id => ids.add(id))
    })

    const toLoad = [...ids].filter(Boolean)
    if (toLoad.length > 0) {
      loadUser(toLoad)
    }
  }, [all, loadUser])

  return <>{children}</>
}

export default NotificationListProvider
